module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-result"
  }, [_c('div', {
    staticClass: "order-result-block-1"
  }, [_c('div', {
    staticClass: "order-result-block-1__col-1"
  }, [_c('div', {
    staticClass: "order-result-block-1__text-container text-container"
  }, [(_vm.mode === 'private') ? _c('h3', [_vm._v("Dein Bio-Abo")]) : (_vm.subscriptionType) ? _c('h3', [_vm._v(_vm._s(_vm.subscriptionType.name) + "-Korb")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Aus den Angaben ergibt sich folgende Abo-Empfehlung:")])])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-block-1__col-2"
  }, [_c('results-summary'), _vm._v(" "), _c('div', {
    staticClass: "order-result-block-1__link-container"
  }, [_c('a', {
    staticClass: "order-result-block-1__link-info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePriceSummaryModalVisible.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Preiszusammenstellung\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "order-result-block-1__link-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleEditModalVisible.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Abo anpassen\n                ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-533bad02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Results.vue
// module id = 753
// module chunks = 0